import { Type } from '@sinclair/typebox';
import { InsertAfterMarketVisitSchema, SelectAfterMarketVisitSchema, } from '../../domain/after-market/after-market.js';
const AfterMarketVisitSchema = Type.Omit(SelectAfterMarketVisitSchema, ['projectId']);
export const ListAfterMarketResponseSchema = Type.Array(AfterMarketVisitSchema);
export const AfterMarketParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const ReplaceAfterMarketBodyRowSchema = Type.Omit(InsertAfterMarketVisitSchema, [
    'projectId',
]);
export const ReplaceAfterMarketBodySchema = Type.Array(ReplaceAfterMarketBodyRowSchema);
